<template>
  <section id="intro" class="intro">
    <div class="intro__inner">
      <img
        src="images/josch26.jpeg"
        alt="Profile Image"
        class="intro__avatar"
      />
      <p class="intro__eyebrow">AI Engineer</p>
      <h1 class="intro__name">Josch Rossa MSc</h1>
      <div class="intro__bio glass-card">
        <p class="intro__description">
          {{ $t("Summary.aboutMe") }}
          <a :href="$t('Summary.propOneLink')" class="intro__link">{{
            $t("Summary.propOne")
          }}</a
          >&nbsp;
          <a :href="$t('Summary.propTwoLink')" class="intro__link">{{
            $t("Summary.propTwo")
          }}</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "JroHeader",
});
</script>

<style lang="scss" scoped>
@use "../global.scss" as *;

.intro {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6rem 1.5rem 4rem;
  text-align: center;
}

.intro__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 42rem;
}

.intro__avatar {
  width: 8rem;
  height: 8rem;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--brand-petal);
  box-shadow: var(--shadow-soft-lg);
}

.intro__eyebrow {
  margin-top: 1.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--muted-foreground);
}

.intro__name {
  margin-top: 0.75rem;
  font-size: clamp(2rem, 5vw, 2.75rem);
  font-weight: 600;
  line-height: 1.1;
  letter-spacing: -0.02em;
  color: var(--foreground);
}

.intro__bio {
  margin-top: 2rem;
  width: 100%;
  padding: 1.5rem 1.75rem;
  text-align: left;
}

.intro__description {
  font-size: 1.0625rem;
  line-height: 1.7;
  color: var(--muted-foreground);
}

.intro__link {
  color: var(--brand-secondary);
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.2s;

  &:hover {
    color: var(--brand-icy);
  }
}

@media (max-width: $bp-medium) {
  .intro {
    padding-top: 5rem;
  }
}
</style>
